import { Guid } from "guid-typescript";
import { SystemSettingGroup } from "src/app/interfaces/Index";
import { Service } from "./Service";

const endpoint = "SystemSettingGroup";
export const SystemSettingGroupService = {
	endpoint,
	createSingle: async (data: SystemSettingGroup) => await Service.createSingle(endpoint, data),
	getAll: async () => await Service.getAll(endpoint),
	getSingleById: async (id: number) => await Service.getSingleById(endpoint, id),
	getSingleByLookupId: async (id: Guid) => await Service.getSingleByLookupId(endpoint, id),
	updateSingleById: async (id: number, data: SystemSettingGroup) => await Service.updateSingleById(endpoint, id, data)
}